module.exports = __webpack_public_path__ + "img/logo.fc922139.png";